import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  updateLocation: [],
  loading: false,
  error: null,
};

const updateLocationSlice = createSlice({
  name: "updateLocation",
  initialState,
  reducers: {
    fetchUpdateLocationSuccess: (state, action) => {
      state.loading = false;
      state.updateLocation = action.payload;
      state.error = null;
    },
    fetchUpdateLocationFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  fetchUpdateLocationSuccess,
  fetchUpdateLocationFailure,
} = updateLocationSlice.actions;

export default updateLocationSlice.reducer;